import React from "react";
import clsx from "clsx";

import { TableRow, TableCell, Box } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellLast: {
    width: "fitContent",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.primary.main,
    height: "35px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
  status: {
    fontSize: "14px",
    marginRight: "5px",
  },
}));

const HubbleRefereeTableItem = ({ row }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.hubbleForm.major}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.participent?.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.participent?.personnelCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.participent?.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.referee?.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {row?.allowedToProceedToNextLevel ? "بله" : "خیر"}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellLast)}
        >
          <Box
            className={classes.createIconContainer}
            onClick={() => history.push(`/hubbleRefereeDetails/${row._id}`)}
          >
            نمایش
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

export default HubbleRefereeTableItem;
